import { createSelector } from '@reduxjs/toolkit';
import { selfMsgSelector } from './self';

const msgsSelector = createSelector(selfMsgSelector, (messages) => messages.messages);

export default msgsSelector;
